
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TranscriptAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeslotid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weekOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"monthOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yearOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcriptAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeslotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeslotid"}}},{"kind":"Argument","name":{"kind":"Name","value":"dayOffset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayOffset"}}},{"kind":"Argument","name":{"kind":"Name","value":"weekOffset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weekOffset"}}},{"kind":"Argument","name":{"kind":"Name","value":"monthOffset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthOffset"}}},{"kind":"Argument","name":{"kind":"Name","value":"yearOffset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yearOffset"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"received"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagged"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pending"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"growth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"week"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"received"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagged"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pending"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"growth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"month"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"received"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagged"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pending"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"growth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"year"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"received"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flagged"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pending"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"growth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":909}};
    doc.loc.source = {"body":"query TranscriptAnalytics(\n  $timeslotid: String!\n  $dayOffset: Int\n  $weekOffset: Int\n  $monthOffset: Int\n  $yearOffset: Int\n) {\n  transcriptAnalytics(\n    timeslotId: $timeslotid\n    dayOffset: $dayOffset\n    weekOffset: $weekOffset\n    monthOffset: $monthOffset\n    yearOffset: $yearOffset\n  ) {\n    day {\n      period\n      received\n      approved\n      flagged\n      pending\n      growth\n      stats {\n        label\n        total\n      }\n    }\n    week {\n      period\n      received\n      approved\n      flagged\n      pending\n      growth\n      stats {\n        label\n        total\n      }\n    }\n    month {\n      period\n      received\n      approved\n      flagged\n      pending\n      growth\n      stats {\n        label\n        total\n      }\n    }\n    year {\n      period\n      received\n      approved\n      flagged\n      pending\n      growth\n      stats {\n        label\n        total\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["TranscriptAnalytics"] = oneQuery(doc, "TranscriptAnalytics");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/voiceintelligence/transcriptAnalyticsQuery.gql
// module id = 2649
// module chunks = 3